import ApiService from './api.service'

const MediaRoleService = {
  venues () {
    return ApiService.get('api/scorekeeper/media/venues')
  },

  games (filter) {
    return ApiService.get('api/scorekeeper/media/games', { params: { filter } })
  }
}

export default MediaRoleService
